define('collections/customers',['require','collections/base','models/customer'],function(require){

    var BaseCollection = require('collections/base');
    var Model = require("models/customer");

    return BaseCollection.extend({
        model: Model,
        url: 'customers.json'
    });
});

